(function () {
  'use strict';

  const STORAGE_KEY = 'pethouse_wishlist_v1';
  let renderQueued = false;

  function getWishlist() {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}

    // Update the UI immediately. Do not wait for a page refresh.
    updateWishlistUI();
  }

  function productFromButton(button) {
    return {
      id: String(button.dataset.wishlistId || ''),
      handle: button.dataset.wishlistHandle || '',
      title: button.dataset.wishlistTitle || 'Product',
      url: button.dataset.wishlistUrl || '#',
      image: button.dataset.wishlistImage || '',
      price: button.dataset.wishlistPrice || '',
      variantId: String(button.dataset.wishlistVariantId || ''),
      available: String(button.dataset.wishlistAvailable || '').toLowerCase() === 'true'
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function updateButtons(items) {
    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      const saved = items.some(function (item) {
        return String(item.id) === String(button.dataset.wishlistId || '');
      });

      button.classList.toggle('is-active', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
      button.title = saved ? 'Remove from wishlist' : 'Add to wishlist';
    });
  }

  function updateCount(items) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
      badge.textContent = String(items.length);
      badge.classList.toggle('hidden', items.length === 0);
    });
  }

  function renderDrawer(items) {
    const list = document.querySelector('[data-wishlist-list]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!list || !empty) return;

    // Rebuild only the product rows. Empty state remains in the DOM.
    list.querySelectorAll('.pethouse-wishlist-item').forEach(function (row) {
      row.remove();
    });

    empty.hidden = items.length !== 0;

    const fragment = document.createDocumentFragment();

    items.forEach(function (item) {
      const row = document.createElement('div');
      row.className = 'pethouse-wishlist-item';
      row.dataset.wishlistItemId = String(item.id);

      row.innerHTML =
  '<a class="pethouse-wishlist-item__image" href="' + escapeHtml(item.url) + '" aria-label="' + escapeHtml(item.title) + '">' +
    (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
  '</a>' +
  '<div class="pethouse-wishlist-item__content">' +
    '<a class="pethouse-wishlist-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
    '<div class="pethouse-wishlist-item__price">' + escapeHtml(item.price) + '</div>' +
    
    (item.available !== false
      ? '<button type="button" class="pethouse-wishlist-item__add-cart" data-wishlist-add-cart="' + escapeHtml(item.variantId) + '">Add to cart</button>'
      : '<button type="button" class="pethouse-wishlist-item__add-cart" disabled>Out of Stock</button>') +

    '<button type="button" class="pethouse-wishlist-item__remove" data-wishlist-remove="' + escapeHtml(item.id) + '">Remove</button>' +
  '</div>';

      fragment.appendChild(row);
    });

    list.appendChild(fragment);
  }

  function updateWishlistUI() {
    const items = getWishlist();
    updateCount(items);
    updateButtons(items);
    renderDrawer(items);
  }

  function queueUIUpdate() {
    if (renderQueued) return;
    renderQueued = true;
    window.requestAnimationFrame(function () {
      renderQueued = false;
      updateWishlistUI();
    });
  }

  function getDrawer() {
    return document.querySelector('[data-wishlist-drawer]');
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    // Render first, then open. This guarantees the newly added item is visible.
    updateWishlistUI();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pethouse-wishlist-open');
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pethouse-wishlist-open');
  }

  function toggleProduct(button) {
    const item = productFromButton(button);
    if (!item.id) return;

    const items = getWishlist();
    const index = items.findIndex(function (existing) {
      return String(existing.id) === String(item.id);
    });

    if (index >= 0) {
      // Remove from wishlist.
      items.splice(index, 1);
      saveWishlist(items);
      // Keep drawer open and reflect removal immediately.
      openDrawer();
    } else {
      // Add to wishlist.
      items.push(item);
      saveWishlist(items);
      // Open immediately and show the new product without refresh.
      openDrawer();
    }
  }

  function addWishlistItemToCart(button) {
    const variantId = String(button.dataset.wishlistAddCart || '');
    if (!variantId || button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Unable to add product to cart.');
        });
      }
      return response.json();
    })
    .then(function () {
      button.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:updated'));

      // Let themes/apps that expose a cart refresh hook update their cart bubble/drawer.
      if (window.Shopify && typeof window.Shopify.theme === 'object') {
        document.dispatchEvent(new CustomEvent('pethouse:wishlist-cart-added'));
      }

      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 1200);
    })
    .catch(function (error) {
      console.error('Wishlist add to cart:', error);
      button.disabled = false;
      button.textContent = 'Try again';
      window.setTimeout(function () {
        button.textContent = originalText;
      }, 1500);
    });
  }

  // One delegated listener handles both product hearts and drawer buttons.
  document.addEventListener('click', function (event) {
    const wishlistButton = event.target.closest && event.target.closest('[data-wishlist-button]');
    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleProduct(wishlistButton);
      return;
    }

    const addCartButton = event.target.closest && event.target.closest('[data-wishlist-add-cart]');
    if (addCartButton) {
      event.preventDefault();
      event.stopPropagation();
      addWishlistItemToCart(addCartButton);
      return;
    }

    const removeButton = event.target.closest && event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();

      const id = String(removeButton.dataset.wishlistRemove || '');
      const row = removeButton.closest('.pethouse-wishlist-item');

      // Remove the row immediately for instant visual feedback.
      if (row) row.remove();

      const items = getWishlist().filter(function (item) {
        return String(item.id) !== id;
      });

      saveWishlist(items);
      // Re-sync all heart states and empty state immediately.
      updateWishlistUI();
      return;
    }

    const openButton = event.target.closest && event.target.closest('[data-wishlist-open]');
    if (openButton) {
      event.preventDefault();
      openDrawer();
      return;
    }

    const closeButton = event.target.closest && event.target.closest('[data-wishlist-close]');
    if (closeButton) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  // Keep the UI in sync if another script changes the wishlist in this tab.
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) queueUIUpdate();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateWishlistUI();
  });

  // Some Shopify sections can be re-rendered after initial page load.
  // Re-sync after Shopify/theme DOM updates without changing any header markup.
  document.addEventListener('shopify:section:load', queueUIUpdate);
  document.addEventListener('shopify:section:reorder', queueUIUpdate);
  document.addEventListener('shopify:block:select', queueUIUpdate);
})();
